import { Card } from '@features/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  MarketDataFormData,
  schemaMarketData,
} from '@src/types/productsAddons.ts';
import {
  getProductDetail,
  saveProductMarketData,
} from '@src/services/products.ts';
import {
  buildProductMarketData,
  mapperProductMarketData,
} from '@lib/products.ts';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { MarketDataForm } from '@features/admin/productsAddons/MarketDataForm.tsx';

export const MarketDataEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  const handleSubmitForm = async (data: MarketDataFormData) => {
    try {
      const makeData = buildProductMarketData(data);

      await saveProductMarketData(Number(id), makeData);
    } catch {
      toast.error('Something went wrong. Please try again later.');
    }
  };

  const method = useForm<MarketDataFormData>({
    resolver: yupResolver(schemaMarketData),
  });

  useEffect(() => {
    if (!id) return;
    getProductDetail(Number(id))
      .then((res) => {
        const productFormData = mapperProductMarketData(res.data);

        method.reset(productFormData);
      })
      .catch(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        alert('Product not found!');
        navigate('/admin/products-addons');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <div className={'flex'}>
        <div className={'flex flex-col gap-y-2.5 mb-4'}>
          <p className={'text-[23px] font-medium text-blue'}>
            Market Data Edit
          </p>
          <div className={'h-[2px] w-full bg-blue'} />
        </div>
      </div>
      <Card>
        <FormProvider {...method}>
          <form
            autoComplete="off"
            onSubmit={method.handleSubmit(handleSubmitForm)}
          >
            <MarketDataForm {...method} />
          </form>
        </FormProvider>
      </Card>
    </div>
  );
};
